
function checkPermission(el, binding) {
  const { value } = binding
  // const roles = store.getters && store.getters.roles
  const roles = JSON.parse(localStorage.getItem('rights')) // 用户权限列表

  // console.log('el', el, binding, value, roles)
  if (roles[0] == '*') {
    return true
  }
  if (value && value instanceof Array) {
    if (value.length > 0) {
      const permissionRoles = value
      const hasPermission = roles.some(() => {
        // return permissionRoles.includes(role)

        // 数组a中的元素是否在数组b中出现过，如果出现过返回true，否则返回false
        const b = permissionRoles
        const a = roles
        for (const m in a) {
          for (const n in b) {
            if (a[m] == b[n]) {
              return true
            }
          }
        }
        return false
      })
      // console.log('是否有权访问', hasPermission)
      if (!hasPermission) {
        // 返回false时删除当前Dom
        // console.log('是否有权访问', hasPermission, el.parentNode)
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  } else {
    throw new Error(`need roles! Like v-permission="['admin','editor']"`)
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}
